import { useContext } from "react";
import PropTypes from "prop-types";
import { PagedMenuContext } from "./PagedMenuContext";

function MenuPage({ id, children }) {
  const { currentPage } = useContext(PagedMenuContext);

  return id === currentPage && children;
}

MenuPage.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

MenuPage.displayName = "PagedMenu.Page";

export default MenuPage;
